import { Currency } from '../enums';

export const currencies = Object.keys(Currency).map((currency) => ({ label: currency, value: currency }));
